
import { useEffect, useState } from "react"
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';

import { NumberFormatMoney } from './useForm';
import {
    Alert, createTheme, ThemeProvider,
    Table, TableBody, TableCell, TableContainer, TableHead, TablePagination,
    TableRow, TableSortLabel, Toolbar, Typography, Paper, Button, ButtonGroup,
    TextField, InputAdornment, Box, Collapse, IconButton, lighten
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import { esES } from "@mui/material/locale";
import jwt_decode from "jwt-decode";

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    { id: 'clave', numeric: false, disablePadding: false, label: 'Clave' },
    { id: 'descripcion', numeric: false, disablePadding: false, label: 'Descripción' },
    { id: 'responsable', numeric: false, disablePadding: false, label: 'Responsable' },
    { id: 'montoMaximo', numeric: true, disablePadding: false, label: 'Presupuesto Asignado' },
];


function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };
    return (
        <TableHead>
            <TableRow>

                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={'left'}
                        padding={'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? '' : ''}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
                <TableCell
                    align={'left'}
                    padding={'normal'}> </TableCell>
                <TableCell
                    align={'left'}
                    padding={'normal'}> </TableCell>
                <TableCell
                    align={'left'}
                    padding={'normal'}> </TableCell>
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.func.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};


const useToolbarStyles = makeStyles()((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    title: {
        flex: '1 1 100%',
    }
}));

const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();

    return (
        <Toolbar>
            <Typography className={classes.title} variant="h6" id="tableTitle" component="div" align="center">
                Proyectos
            </Typography>
        </Toolbar>
    );
};



const theme = createTheme(esES);

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
}));

export default function ProyectosPlanLista(props) {
    const [loading, setLoading] = useState(false)
    const [proyectos, setProyectos] = useState(props.plan.proyectoPlans)
    const { setProyectoPlan, setIsEditing, plan, setPlanPresupuestal, planeacion, isCoordinacion } = props
    const [open, setOpen] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [fase, setFase] = useState(props.fase)
    const [perfilAuxiliar, setPerfilAuxiliar] = useState(false)
    const token = sessionStorage.getItem('token')
    const decoded = jwt_decode(token);
    const idUsuario = decoded.id;



    const handleNotificarModificaciones = async (proyecto) => {
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/planeacion/notificarModificaciones/${proyecto.id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            },
            body: JSON.stringify({ idRegistrante: idUsuario })
        })
        const data = await res.json()
        //colocar un mensaje para orientar al usuario, se está validando desde sequelize

        if(res.status === 200)
            setSeverity('success')
        else
            setSeverity('error')
        if (data.message) {
            setOpen(true)
            if (data.message === 'Se han enviado los emails para notificar que hubo un ajuste')
                proyecto.ajustes = 0
            setMensaje(data.message)
            setLoading(false)
            return
        }
    }

    const handleUpdate = async (proyecto) => {
        proyecto.montoPrevio = proyecto.montoMaximo
        proyecto.prioridad1MontoPrevio = proyecto.prioridad1
        proyecto.prioridad2MontoPrevio = proyecto.prioridad2
        if (proyecto.tipo === 'investigacion') {
            const responseProyectoInvestigacion = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/proyectos/investigacion/proyecto/${proyecto.idProyectoInvestigacion}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            })
            const proyectoInvestigacion = await responseProyectoInvestigacion.json()
            //console.log(`proyectoInvestigacion ${proyectoInvestigacion.clave} ${proyectoInvestigacion.acuerdo} ${proyectoInvestigacion.vigencia}`)
            proyecto.clave = proyectoInvestigacion.clave
            proyecto.acuerdo = proyectoInvestigacion.acuerdo
            proyecto.montoPrevio = proyecto.montoMaximo
            if (proyectoInvestigacion.vigencia) {
                const arrayFecha = proyectoInvestigacion.vigencia.split('-')
                proyecto.vigencia = `${arrayFecha[1]}/${arrayFecha[2]}/${arrayFecha[0]}`
            }
            else
                proyecto.vigencia = ''
        }

        setProyectoPlan(proyecto)
        setIsEditing(true)
        //console.log(proyecto)
    }
    const verAvancePresupuestal = () => {
        const idEntidad = sessionStorage.getItem('idEntidad')
        const idEntidadSuperior = sessionStorage.getItem('idEntidadSuperior')
        if (Number(idEntidad) === Number(1) || Number(idEntidad) === Number(2) || Number(idEntidadSuperior) === Number(1) || Number(idEntidadSuperior) === Number(2)) {
            return false
        }
        return true
    }
    const handleDelete = async (id) => {
        setLoading(true)
        try {
            const resDelete = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/proyectosPlan/${id}`, {
                method: "DELETE",
                headers: {
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            })
            if (resDelete.status === 403) {
                setOpen(true)
                setSeverity('warning')
                setMensaje(`La sesión ha expirado, cierre su sesión (Botón LOGOUT) y vuelva a loguearse`)
                return
            }
            setProyectos(proyectos.filter(proyectos => proyectos.id !== id))
            // Actualizar los montos del plan
            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/planeacion/${plan.idPlanPresupuestal}`, {
                method: "GET",
                headers: {
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            })
            const data = await res.json()
            //console.log(`PLAN ${JSON.stringify(data)}`)
            setFase(1)
            setPlanPresupuestal(data)

        } catch (error) {
            setSeverity('error')
            setMensaje(error)
            setOpen(true)
        }
        setLoading(false)
    }
    useEffect(() => {
        (async () => {
            setProyectos(props.plan.proyectoPlans)
            const resPerfilAuxiliar = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/usuarios/esPerfilAuxiliar/${plan.idResponsable}/${idUsuario}/${plan.idEntidad}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            })
            if (resPerfilAuxiliar.status === 404 || resPerfilAuxiliar.status === 500)
                setPerfilAuxiliar(false)
            else
                setPerfilAuxiliar(true)
        })();
    }, [fase, props.plan])
    const classes = useStyles();
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('clave');
    const [page, setPage] = useState(0);
    const [severity, setSeverity] = useState('error')

    const [rowsPerPage, setRowsPerPage] = useState(5);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };





    const emptyRows = rowsPerPage - Math.min(rowsPerPage, proyectos.length - page * rowsPerPage);

    return (

        <div className={classes.root} style={{ marginTop: 50 }}>

            <Paper className={classes.paper}>
                <Box sx={{ width: '100%' }}>
                    <Collapse in={open}>
                        <Alert severity={severity}
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpen(false);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                            style={{ marginTop: 30 }}
                        >
                            {mensaje}
                        </Alert>
                    </Collapse>
                </Box>
                <EnhancedTableToolbar />
                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size={'medium'}
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            classes={classes}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            rowCount={proyectos.length}
                        />
                        <TableBody>
                            {stableSort(proyectos, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {

                                    const labelId = `enhanced-table-checkbox-${index}`;

                                    return (

                                        <TableRow
                                            hover
                                            tabIndex={-1}
                                            key={row.descripcion}
                                        >
                                            <TableCell align="left">
                                                {row.clave}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row" padding="normal">{row.descripcion}</TableCell>
                                            <TableCell align="left">{row.responsable}</TableCell>
                                            <TableCell align="left">

                                                <NumberFormat value={row.montoMaximo} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} />
                                            </TableCell>
                                            <TableCell align="left">
                                                {(row.elaboracionInforme === 1 && Boolean(perfilAuxiliar)) ? <Button variant='contained' style={{ marginTop: 20, backgroundColor: "darkblue", color: 'white' }} disabled={loading}><Link to={`/proyectosInforme/${idUsuario}/${planeacion}`} style={{ textDecoration: 'none', color: 'white' }}>Realizar Informe</Link></Button> : (row.elaboracionInforme === 1 && (plan.idResponsable === row.idResponsable)) ? <Button variant='contained' style={{ marginTop: 20, backgroundColor: "darkblue", color: 'white' }} disabled={loading}><Link to={`/proyectosInforme/${row.idResponsable}/${planeacion}`} style={{ textDecoration: 'none', color: 'white' }}>Realizar Informe</Link></Button> : <></>}
                                                {row.elaboracionInforme === 2 ? Boolean(perfilAuxiliar) ? <Button variant='contained' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white' }} disabled={loading}><Link to={`/proyectosInforme/${idUsuario}/${planeacion}`} style={{ textDecoration: 'none', color: 'white' }}>Informe</Link></Button> : <Button variant='contained' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white' }} disabled={loading}><Link to={`/proyectosInforme/${row.idResponsable}/${planeacion}`} style={{ textDecoration: 'none', color: 'white' }}>Informe</Link></Button> : <></>}
                                                {fase === 3 && verAvancePresupuestal() ? <Button variant='contained' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white' }}><Link to={`/proyectoInforme/${row.id}`} style={{ textDecoration: 'none', color: 'white' }}>Proyecto</Link></Button> :
                                                    <></>
                                                }
                                                {row.ajustes === 1 ? <Button variant='contained' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white' }} onClick={() => { handleNotificarModificaciones(row) }} disabled={loading}>Notificar Modificaciones</Button> : <></>}
                                            </TableCell>
                                            <TableCell align="left" style={{ width: '250px', whiteSpace: 'nowrap' }}>
                                                <TextField InputProps={{
                                                    inputComponent: NumberFormatMoney,
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            $
                                                        </InputAdornment>
                                                    )
                                                }} defaultValue={row.prioridad1} disabled
                                                    label='Prioridad 1' variant='outlined' style={{ width: '120px', marginRight: '10px' }}
                                                />
                                                <TextField InputProps={{
                                                    inputComponent: NumberFormatMoney,
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            $
                                                        </InputAdornment>
                                                    ),
                                                }} defaultValue={row.prioridad2} disabled
                                                    label='Prioridad 2' variant='outlined' style={{ width: '120px' }}
                                                />
                                            </TableCell>


                                            <TableCell align="left" style={{ width: 20 }}>
                                                { isNaN(planeacion) ?
                                                    <ButtonGroup disableElevation variant="outlined" color="primary">
                                                        {(!isCoordinacion || (isCoordinacion && fase === 0)) ? <Button variant='contained' color='inherit' id={`enviar${row.id}`} onClick={() => handleUpdate(row)} disabled={loading}>Editar</Button> : <></>}

                                                        {((fase === 3 && row.montoMaximo !== 0) || (isCoordinacion && fase > 0)) ? <></> :
                                                            <Button variant='contained' style={{ marginLeft: 5, backgroundColor: "darkred", color: 'white' }} onClick={() => handleDelete(row.id)} disabled={loading}>Eliminar</Button>
                                                        }
                                                    </ButtonGroup>:<></>
                                                }
                                            </TableCell>


                                        </TableRow>

                                    );
                                })}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: (53) * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <ThemeProvider theme={theme}>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 15]}
                        component="div"
                        count={proyectos.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </ThemeProvider>
            </Paper>

        </div>
    );
}